import PropTypes from 'prop-types';
import { Component } from 'react';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import UnderConstruction from '../../../../Doc/components/UnderConstruction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import H6 from 'UIComponents/elements/headings/H6';
import Code from 'UIComponents/elements/Code';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ValidRange extends Component {
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      schema
    } = this.props;
    if (schema.type !== 'integer') {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: `ValidRange: ${schema.type}`
      });
    }
    const min = !isNaN(schema.minimum) ? schema.minimum : -Infinity;
    const max = !isNaN(schema.maximum) ? schema.maximum : Infinity;
    return /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-2",
      children: [/*#__PURE__*/_jsx(H6, {
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.body.validRange.header"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "developer-docs-shared-components.params.body.validRange.numberRange_jsx",
        elements: {
          Code
        },
        options: {
          min,
          max
        }
      })]
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ValidRange.propTypes = {
  schema: PropTypes.object.isRequired
};